import * as actions from '../utils/Constants';
import { apiGet, apiDeleteWithBodyAndThen } from '../utils/Api';

const api = `${process.env.REACT_APP_API_HOST}api/sessions/`;
const apiSession = `${process.env.REACT_APP_API_HOST}api/session/`;

export const getSessions = () => {
    return {
        type: actions.GET_SESSIONS,
        payload: fetch(api, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getSession = (id) => {
    return {
        type: actions.GET_SESSION,
        payload: fetch(`${apiSession}${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteSessions = (ids = []) => ({
    type: actions.DELETE_SESSION,
    payload: apiDeleteWithBodyAndThen(api, ids, () => apiGet(api))
});

export const newSession = () => ({ type: actions.NEW_SESSION })
